import { connect } from 'react-redux';
import {
  getNutritionPlan,
  editMeal,
  getMeasures
} from 'features/nutrition/ducks/nutritionActions';
import React from 'react';
import MealForm from './MealForm';

class EditMeal extends React.Component {
  constructor(props) {
    super(props);
    this.planId = this.props.match.params.plan_id;
    this.mealId = this.props.match.params.id;
  }

  componentDidMount() {
    this.props.getNutritionPlan(this.planId, this.props.history);
  }

  render() {
    const {
      nutritionPlan,
      editMeal,
      history,
      getMeasures,
      measurementsUnits,
      loadingMeasurements
    } = this.props;
    const meal =
      nutritionPlan &&
      nutritionPlan.meal_items &&
      nutritionPlan.meal_items[this.mealId];
    if (meal) meal.index = this.mealId;

    return nutritionPlan && meal ? (
      <MealForm
        nutritionPlan={nutritionPlan}
        updateMeal={editMeal}
        initialMeal={meal}
        headerTitle={meal.name}
        pageTitle={'Edit'}
        history={history}
        getMeasures={getMeasures}
        measurementsUnits={measurementsUnits}
        loadingMeasurements={loadingMeasurements}
      />
    ) : null;
  }
}

function mapStateToProps(state) {
  return {
    nutritionPlan: state.nutritionReducer.currentNutritionPlan,
    measurementsUnits: state.nutritionReducer.food.measurementsUnits,
    loadingMeasurements: state.nutritionReducer.food.loadingMeasurements
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getNutritionPlan: (planId, history) =>
      dispatch(getNutritionPlan(planId, history)),
    editMeal: (plan, meal, history) => dispatch(editMeal(plan, meal, history)),
    getMeasures: (query, weight, calories, measure, quantity_size) => dispatch(getMeasures(query, weight, calories, measure, quantity_size))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditMeal);
